import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'yesno',
  standalone: false
})
export class YesnoPipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  transform(value: any): any {
    if (value === 0 || value === '0') {
      return this.translateService.instant('i18n.common.no');
    }
    return this.translateService.instant('i18n.common.yes');
  }
}
